import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { YodaJustifyContent, YodaSpacing } from 'yoda-ui/yodaTheme';

export const headerWrapperStyle: SxProps<Theme> = () => ({
  marginBottom: '32px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: YodaJustifyContent.spaceBetween,
  alignItems: YodaJustifyContent.flexStart,
  gap: YodaSpacing.small,

  '& .MuiBox-root': {
    marginBottom: 0,
  },

  '@media (min-width: 1200px)': {
    flexDirection: 'row',
  },
});
